import { defineStore } from 'pinia'
import { ref } from 'vue'

export type GroupDisplay = '' | 'event' | 'ticketset' | 'price' | 'ticketset_price'
export type SettingsLang = 'cs' | 'de' | 'en' | 'hr' | 'hu' | 'pl' | 'sk'

export interface SettingsState {
    sound: boolean
    camera: string
    nfc: boolean
    lang: SettingsLang
    videoHeight: number
    group: GroupDisplay
    olderEvents: number
    patchSize: number
    halfSample: boolean
    numOfWorkers: number
    frequency: number
    showTicketCount: boolean
}

const initial: SettingsState = {
    sound: true,
    camera: '',
    nfc: false,
    lang: 'cs',
    videoHeight: 300,
    group: '',
    olderEvents: 30,
    patchSize: 60,
    halfSample: true,
    numOfWorkers: 2,
    frequency: 10,
    showTicketCount: true
}

export const useSettingsStore = defineStore('settings', () => {
    const sound = ref(initial.sound)
    const camera = ref(initial.camera)
    const nfc = ref(initial.nfc)
    const lang = ref<SettingsLang>(initial.lang)
    const videoHeight = ref(initial.videoHeight)
    const group = ref<GroupDisplay>(initial.group)
    const olderEvents = ref(initial.olderEvents)
    const patchSize = ref(initial.patchSize)
    const halfSample = ref(initial.halfSample)
    const numOfWorkers = ref(initial.numOfWorkers)
    const frequency = ref(initial.frequency)
    const showTicketCount = ref(initial.showTicketCount)

    function reset() {
        sound.value = initial.sound
        camera.value = initial.camera
        nfc.value = initial.nfc
        lang.value = initial.lang
        videoHeight.value = initial.videoHeight
        group.value = initial.group
        olderEvents.value = initial.olderEvents
        patchSize.value = initial.patchSize
        halfSample.value = initial.halfSample
        numOfWorkers.value = initial.numOfWorkers
        frequency.value = initial.frequency
        showTicketCount.value = initial.showTicketCount
    }

    return {
        sound,
        camera,
        nfc,
        lang,
        videoHeight,
        group,
        olderEvents,
        patchSize,
        halfSample,
        numOfWorkers,
        frequency,
        showTicketCount,
        reset
    }
})
